/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "../../../../services/googleAnalyticsService";

const ImprintPageMeta = () => {
  const title = "Impressum | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Lesen Sie hier unser Impressum von Legalbird" />
      <meta name="keywords" content="Impressum" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Lesen Sie hier unser Impressum von Legalbird" />
    </Helmet>
  );
};

export default ImprintPageMeta;
